<div>
  <p>
    {{ moreDetails?.addressLine1 }}, {{ moreDetails?.addressLine2
    }}<span *ngIf="moreDetails?.addressLine2">,</span>
    {{ moreDetails?.stateCode }}, {{ moreDetails?.city }},
    <span>District</span> {{ moreDetails?.geographicalDistrictCode }}
  </p>
  <p>
    <span>
      <fa-icon icon="location-crosshairs" class="fa-md k-pr-2 icon-color k-align-self-center"></fa-icon> </span>{{
    moreDetails?.boroNames }}
  </p>
  <p>
    <span>
      <fa-icon icon="language" class="fa-md k-pr-2 icon-color k-align-self-center"></fa-icon></span>{{
    moreDetails?.languageList }}
  </p>
</div>